/*
 * @Author: 肖玲
 * @Date: 2023-02-08 14:37:55
 * @LastEditTime: 2024-05-15 16:54:40
 * @LastEditors: 肖玲
 * @Description:
 * 基础信息
 */
const systemSettingRouter = [
  // 系统自检
  {
    path: '/masterDataSystem/system-self-test',
    name: 'masterDataSystemSystemSelfTest',
    component: () =>
      // import('@/views/masterDataSystem/system-self-test/List.vue'), // 待删除
      import('@/views/master-data/system-settings/system-selftest/Page.vue'),
    meta: {
      SecondaryMenu: '系统设置', //二级菜单
      title: '系统自检'
    }
  },
  // 系统自检 详情
  {
    path: '/masterDataSystem/system-self-test-detail/:id/:type',
    name: 'masterDataSystemSystemSelfTestDetail',
    component: () =>
      // import('@/views/masterDataSystem/system-self-test/Detail.vue'),//待删除
      import('@/views/master-data/system-settings/system-selftest/Detail.vue'),
    meta: {
      SecondaryMenu: '系统设置', //二级菜单
      title: '自检详情',
      breadcrumb: [
        {
          title: '系统自检',
          name: 'masterDataSystemSystemSelfTest'
        }
      ]
    }
  },
  // 系统自检 自检设置
  {
    path: '/masterDataSystem/system-self-test-detailedit',
    name: 'masterDataSystemSystemSelfTestEdit',
    component: () =>
      // import('@/views/masterDataSystem/system-self-test/Edit.vue'), //待删除
      import(
        '@/views/master-data/system-settings/system-selftest/SelfInspection.vue'
      ),
    meta: {
      SecondaryMenu: '系统设置', //二级菜单
      title: '自检设置',
      breadcrumb: [
        {
          title: '系统自检',
          name: 'masterDataSystemSystemSelfTest'
        }
      ]
    }
  },

  // 系统配置
  {
    path: '/masterDataSystem/md-setting',
    name: 'masterDataSettingManage',
    component: () =>
      // import(
      //   /*webpackChunkName:"field" */
      //   '@/views/masterDataSystem/setting/Manage.vue'
      // ), //待删除
      import(
        /*webpackChunkName:"field" */
        '@/views/master-data/system-settings/system-configuration/Page.vue'
      ),
    meta: {
      SecondaryMenu: '系统设置', //二级菜单
      title: '系统配置'
    }
  },

  // 产品维护方式配置
  {
    path: '/masterDataSystem/md-setting-import',
    name: 'masterDataImportConfig',
    component: () =>
      // import(
      //   /*webpackChunkName:"field" */
      //   '@/views/masterDataSystem/setting/ImportConfig.vue'
      // ), //待删除
      import(
        /*webpackChunkName:"field" */
        '@/views/master-data/system-settings/system-configuration/product-maintenance-method/Page.vue'
      ),
    meta: {
      SecondaryMenu: '系统设置', //二级菜单
      title: '产品维护方式配置',
      breadcrumb: [
        {
          title: '系统配置',
          name: 'masterDataSettingManage'
        }
      ]
    }
  },
  // 信用代码重复配置
  {
    path: '/masterDataSystem/duplicate-credit-code-config',
    name: 'Duplicatereditodeonfig',
    component: () =>
      import(
        /*webpackChunkName:"field" */
        '@/views/master-data/system-settings/system-configuration/duplicate-credit-code-config/Page.vue'
      ),
    meta: {
      SecondaryMenu: '系统设置', //二级菜单
      title: '信用代码重复配置',
      breadcrumb: [
        {
          title: '系统配置',
          name: 'masterDataSettingManage'
        }
      ]
    }
  },

  // 档案字段回传对照-华神
  {
    path: '/masterDataSystem/field-return-comparison-huashen',
    name: 'FieldReturnComparisonHuashen',
    component: () =>
      import(
        /*webpackChunkName:"field" */
        '@/views/master-data/system-settings/system-configuration/field-return-comparison-huashen/Page.vue'
      ),
    meta: {
      SecondaryMenu: '系统设置', //二级菜单
      title: '档案字段回传对照-华神',
      breadcrumb: [
        {
          title: '系统配置',
          name: 'masterDataSettingManage'
        }
      ]
    }
  },
  // 查看数据范围权限配置
  {
    path: '/masterDataSystem/client-view-rang',
    name: 'behaviorManageClientViewRang',
    component: () =>
      // import(
      //   /*webpackChunkName:"behaviorManageAmendRecord" */
      //   '@/views/behaviorManage/ClientViewRang.vue'
      // ), //待删除
      import(
        /*webpackChunkName:"behaviorManageAmendRecord" */
        '@/views/master-data/system-settings/system-configuration/view-data-range/Page.vue'
      ),
    meta: {
      SecondaryMenu: '系统设置', //二级菜单
      title: '查看数据范围权限配置',
      breadcrumb: [
        {
          title: '系统配置',
          name: 'masterDataSettingManage'
        }
      ]
    }
  },

  // 档案维护配置
  {
    path: '/masterDataSystem/set-client-name',
    name: 'masterDataSystemSetClientName',
    component: () =>
      // import(
      //   /*webpackChunkName:"behaviorManageAmendRecord" */
      //   '@/views/masterDataSystem/setClientName/index.vue'
      // ), //待删除
      import(
        /*webpackChunkName:"behaviorManageAmendRecord" */
        '@/views/master-data/system-settings/system-configuration/file-maintenance-config/Page.vue'
      ),
    meta: {
      SecondaryMenu: '系统设置', //二级菜单
      title: '档案维护配置',
      breadcrumb: [
        {
          title: '系统配置',
          name: 'masterDataSettingManage'
        }
      ]
    }
  },
  // 历史数据存储配置
  {
    path: '/masterDataSystem/save-data/:json',
    name: 'masterDataSystemSaveData',
    component: () =>
      // import(
      //   /*webpackChunkName:"masterDataSystemSaveData" */
      //   '@/views/masterDataSystem/SaveData.vue'
      // ),     待删除
      import(
        /*webpackChunkName:"masterDataSystemSaveData" */
        '@/views/master-data/system-settings/system-configuration/historical-data-storage/Page.vue'
      ),
    meta: {
      SecondaryMenu: '系统设置', //二级菜单
      title: '历史数据存储配置',
      breadcrumb: [
        {
          title: '系统配置',
          name: 'masterDataSettingManage'
        }
      ]
    }
  },
  // 档案类型对照表
  {
    path: '/masterDataSystem/FileTypeComparison',
    name: 'FileTypeComparison',
    component: () =>
      import(
        /*webpackChunkName:"masterDataSystemSaveData" */
        '@/views/masterDataSystem/FileTypeComparison.vue'
      ),
    meta: {
      SecondaryMenu: '系统设置', //二级菜单
      title: '档案类型对照表',
      breadcrumb: [
        {
          title: '系统配置',
          name: 'masterDataSettingManage'
        }
      ]
    }
  },
  // 医生等级配置 列表
  {
    path: '/masterDataSystem/doctor-level-config/page',
    name: 'masterDataDoctorLevelConfig',
    component: () =>
      // import(
      //   /*webpackChunkName:"field" */
      //   '@/views/masterDataSystem/setting/DoctorLevel.vue'
      // ), 待删除
      import(
        /*webpackChunkName:"field" */
        '@/views/master-data/system-settings/system-configuration/doctor-level-config/Page.vue'
      ),
    meta: {
      SecondaryMenu: '系统设置', //二级菜单
      title: '医生等级配置',
      breadcrumb: [
        {
          title: '系统配置',
          name: 'masterDataSettingManage'
        }
      ]
    }
  },

  // 医生等级配置 编辑
  {
    path: '/masterDataSystem/doctor-level-config/edit/:id',
    name: 'masterDataDoctorLevelConfigEdit',
    component: () =>
      // import(
      //   /*webpackChunkName:"field" */
      //   '@/views/masterDataSystem/setting/DoctorLevel.vue'
      // ), 待删除
      import(
        /*webpackChunkName:"field" */
        '@/views/master-data/system-settings/system-configuration/doctor-level-config/Edit.vue'
      ),
    meta: {
      SecondaryMenu: '系统设置', //二级菜单
      title: '医生等级配置',
      breadcrumb: [
        {
          title: '系统配置',
          name: 'masterDataSettingManage'
        },
        {
          title: '医生等级配置',
          name: 'masterDataDoctorLevelConfig'
        }
      ]
    }
  },

  // 九新 代理关系  代理商等级配置
  {
    path: '/masterDataSystem/agent-level-deploy',
    name: 'masterDataSystemAgentLevelDeploy',
    component: () =>
      // import(
      //   /*webpackChunkName:"masterDataSystemAgentLevelDeploy" */
      //   '@/views/behaviorManage/jiuxin/AgentLevelDeploy.vue'
      // ), 待删除
      import(
        /*webpackChunkName:"masterDataSystemAgentLevelDeploy" */
        '@/views/master-data/system-settings/system-configuration/agent-level-configuration/Page.vue'
      ),
    meta: {
      SecondaryMenu: '系统设置', //二级菜单
      title: '代理商等级配置',
      breadcrumb: [
        {
          title: '系统配置',
          name: 'masterDataSettingManage'
        }
      ]
    }
  },
  // 配送商等级配置
  {
    path: '/masterDataSystem/distributor-level-configuration',
    name: 'behaviorManageDistributorLevelConfiguration',
    component: () =>
      // import(
      //   /*webpackChunkName:"behaviorManageAmendRecord" */
      //   '@/views/behaviorManage/DistributorLevelConfiguration.vue'
      // ), 待删除
      import(
        /*webpackChunkName:"behaviorManageAmendRecord" */
        '@/views/master-data/system-settings/system-configuration/distributor-level-config/Page.vue'
      ),
    meta: {
      SecondaryMenu: '系统设置', //二级菜单
      title: '配送商等级配置',
      breadcrumb: [
        {
          title: '系统配置',
          name: 'masterDataSettingManage'
        }
      ]
    }
  },
  // 代理关系配置 & 服务商关系配置
  {
    path: '/masterDataSystem/agent-config/:meta_type',
    name: 'masterDataAgentConfig',
    component: () =>
      // import(
      //   /*webpackChunkName:"field" */
      //   '@/views/masterDataSystem/AgentConfig'
      // ), 待删除
      import(
        /*webpackChunkName:"field" */
        '@/views/master-data/system-settings/system-configuration/agent-service-provider-config/Page.vue'
      ),
    meta: {
      SecondaryMenu: '系统设置', //二级菜单
      isMoreMeta: true,
      1: {
        title: '代理关系配置',
        breadcrumb: [
          {
            title: '系统配置',
            name: 'masterDataSettingManage'
          }
        ]
      },
      2: {
        title: '服务商关系配置',
        breadcrumb: [
          {
            title: '系统配置',
            name: 'masterDataSettingManage'
          }
        ]
      }
    }
  },

  // 代理关系  & 服务商关系 审批
  {
    path: '/masterDataSystem/agency-examine/:meta_type',
    name: 'behaviorManageAgencyExamine',
    component: () =>
      // import(
      //   /*webpackChunkName:"behaviorManageAgencyExamine" */
      //   '@/views/behaviorManage/agencyExamine.vue'
      // ), 待删除
      import(
        /*webpackChunkName:"behaviorManageAgencyExamine" */
        '@/views/master-data/system-settings/system-configuration/agent-service-approval/Page.vue'
      ),
    meta: {
      SecondaryMenu: '系统设置', //二级菜单
      isMoreMeta: true,
      1: {
        title: '代理关系审批',
        breadcrumb: [
          {
            title: '系统配置',
            name: 'masterDataSettingManage'
          }
        ]
      },
      2: {
        title: '服务商关系审批',
        breadcrumb: [
          {
            title: '系统配置',
            name: 'masterDataSettingManage'
          }
        ]
      }
    }
  },

  // 配送商 - 配送商账密设置
  {
    path: '/masterDataSystem/distributors-account-set',
    name: 'masterDataSystemDistributorsAccountSet',
    component: () =>
      // import(
      //   /*webpackChunkName:"flowSystemConfig4" */
      //   '@/views/masterDataSystem/DistributorsAccountSet.vue'
      // ), 待删除
      import(
        /*webpackChunkName:"flowSystemConfig4" */
        '@/views/master-data/system-settings/system-configuration/provider-account-secret/Page.vue'
      ),
    meta: {
      SecondaryMenu: '系统设置', //二级菜单
      title: '配送商账密设置',
      breadcrumb: [
        {
          title: '系统配置',
          name: 'masterDataSettingManage'
        }
      ]
    }
  },

  // 配送商 - 配送商账密设置 -查看操作记录
  {
    path: '/masterDataSystem/account-set-record',
    name: 'masterDataSystemAccountSetRecord',
    component: () =>
      // import(
      //   /*webpackChunkName:"masterDataSystemAccountSetRecord" */
      //   '@/views/masterDataSystem/AccountSetRecord.vue'
      // ), 待删除
      import(
        /*webpackChunkName:"masterDataSystemAccountSetRecord" */
        '@/views/master-data/system-settings/system-configuration/provider-account-secret/See.vue'
      ),
    meta: {
      SecondaryMenu: '系统设置', //二级菜单
      title: '查看操作记录',
      breadcrumb: [
        {
          title: '系统配置',
          name: 'masterDataSettingManage'
        },
        {
          title: '配送商账密设置',
          name: 'masterDataSystemDistributorsAccountSet'
        }
      ]
    }
  },

  // 配送商 - 配送商账密设置 -批量设置账号 网站抓取网站维护
  {
    path: '/masterDataSystem/account-list/:client_code/:client_name',
    name: 'masterDataSystemAccountList',
    component: () =>
      // import(
      //   /*webpackChunkName:"masterDataSystemAccountSetRecord" */
      //   '@/views/masterDataSystem/AccountList.vue'
      // ), 待删除
      import(
        /*webpackChunkName:"masterDataSystemAccountSetRecord" */
        '@/views/master-data/system-settings/system-configuration/provider-account-secret/WebMaintenance.vue'
      ),
    meta: {
      SecondaryMenu: '系统设置', //二级菜单
      title: '网站抓取网站维护',
      breadcrumb: [
        {
          title: '系统配置',
          name: 'masterDataSettingManage'
        },
        {
          title: '配送商账密设置',
          name: 'masterDataSystemDistributorsAccountSet'
        }
      ]
    }
  },

  // 配送商 - 配送商账密设置 -批量设置账号
  {
    path: '/masterDataSystem/batch-account-set',
    name: 'masterDataSystemBatchAccountSet',
    component: () =>
      // import(
      //   /*webpackChunkName:"masterDataSystemAccountSetRecord" */
      //   '@/views/masterDataSystem/BatchAccountSet.vue'
      // ), 待删除
      import(
        /*webpackChunkName:"masterDataSystemAccountSetRecord" */
        '@/views/master-data/system-settings/system-configuration/provider-account-secret/BatchSetAccount.vue'
      ),
    meta: {
      SecondaryMenu: '系统设置', //二级菜单
      title: '批量设置账号',
      breadcrumb: [
        {
          title: '系统配置',
          name: 'masterDataSettingManage'
        },
        {
          title: '配送商账密设置',
          name: 'masterDataSystemDistributorsAccountSet'
        }
      ]
    }
  },

  // 配送商 - 新配送商账密设置
  {
    path: '/masterDataSystem/new-account',
    name: 'masterDataSystemNewAccount',
    component: () =>
      // import(
      //   /*webpackChunkName:"flowSystemConfig4" */
      //   '@/views/masterDataSystem/newAccount/list.vue'
      // ), 待删除
      import(
        /*webpackChunkName:"flowSystemConfig4" */
        '@/views/master-data/system-settings/system-configuration/new-provider-account-secret/Page.vue'
      ),
    meta: {
      SecondaryMenu: '系统设置', //二级菜单
      title: '配送商账密设置',
      breadcrumb: [
        {
          title: '系统配置',
          name: 'masterDataSettingManage'
        }
      ]
    }
  },
  // 配送商 - 新配送商账密设置 -编辑账密
  {
    path: '/masterDataSystem/new-account/edit/:client_code/:client_name',
    name: 'masterDataSystemNewAccountEdit',
    component: () =>
      // import(
      //   /*webpackChunkName:"flowSystemConfig4" */
      //   '@/views/masterDataSystem/newAccount/edit.vue'
      // ), 待删除
      import(
        /*webpackChunkName:"flowSystemConfig4" */
        '@/views/master-data/system-settings/system-configuration/new-provider-account-secret/Edit.vue'
      ),
    meta: {
      SecondaryMenu: '系统设置', //二级菜单
      title: '配送商账密设置',
      breadcrumb: [
        {
          title: '系统配置',
          name: 'masterDataSettingManage'
        },
        {
          title: '配送商账密设置',
          name: 'masterDataSystemNewAccount'
        }
      ]
    }
  },
  // 配送商 - 新配送商账密设置 -查看操作记录
  {
    path: '/masterDataSystem/new-account/log',
    name: 'masterDataSystemNewAccountLog',
    component: () =>
      // import(
      //   /*webpackChunkName:"flowSystemConfig4" */
      //   '@/views/masterDataSystem/newAccount/log.vue'
      // ), 待删除
      import(
        /*webpackChunkName:"flowSystemConfig4" */
        '@/views/master-data/system-settings/system-configuration/new-provider-account-secret/SeeOpration.vue'
      ),
    meta: {
      SecondaryMenu: '系统设置', //二级菜单
      title: '查看操作记录',
      breadcrumb: [
        {
          title: '系统配置',
          name: 'masterDataSettingManage'
        },
        {
          title: '配送商账密设置',
          name: 'masterDataSystemNewAccount'
        }
      ]
    }
  },
  // 配送商 - 配送商账密设置 批量更新网址
  {
    path: '/masterDataSystem/batch-account-set/uploadUrl',
    name: 'masterDataSystemBatchUploadUrl',
    component: () =>
      import(
        /*webpackChunkName:"flowSystemConfig4" */
        // '@/views/masterDataSystem/uploadUrl/uploadUrl.vue'
        '@/views/master-data/system-settings/system-configuration/new-provider-account-secret/UpdateUrl.vue'
      ),
    meta: {
      SecondaryMenu: '系统设置', //二级菜单
      title: '批量更新网址',
      breadcrumb: [
        {
          title: '系统配置',
          name: 'masterDataSettingManage'
        },
        {
          title: '配送商账密设置',
          name: 'masterDataSystemNewAccount'
        }
      ]
    }
  },
  // 配送商 - 配送商账密设置 批量更新账密
  {
    path: '/masterDataSystem/distributors-account-set/uploadPas',
    name: 'masterDataSystemDistributorsAccountSetUploadPas',
    component: () =>
      import(
        /*webpackChunkName:"flowSystemConfig4" */
        // '@/views/masterDataSystem/uploadPas/uploadPas.vue'
        '@/views/master-data/system-settings/system-configuration/new-provider-account-secret/UpdatePassword.vue'
      ),
    meta: {
      SecondaryMenu: '系统设置', //二级菜单
      title: '批量更新账密',
      breadcrumb: [
        {
          title: '系统配置',
          name: 'masterDataSettingManage'
        },
        {
          title: '配送商账密设置(新)',
          name: 'masterDataSystemDistributorsAccountSet'
        }
      ]
    }
  },
  // 科室架构职位配置
  {
    path: '/masterDataSystem/department-level-settingList',
    name: 'behaviorManageDepartmentLevelSettingList',
    component: () =>
      // import(
      //   /*webpackChunkName:"behaviorManageAmendRecord" */
      //   '@/views/behaviorManage/departmentLevelSettingList.vue'
      // ),  待删除
      import(
        /*webpackChunkName:"behaviorManageAmendRecord" */
        '@/views/master-data/system-settings/system-configuration/department-structure/Page.vue'
      ),
    meta: {
      SecondaryMenu: '系统设置', //二级菜单
      title: '科室架构职位配置',
      breadcrumb: [
        {
          title: '系统配置',
          name: 'masterDataSettingManage'
        }
      ]
    }
  },
  // 连锁架构标签配置
  {
    path: '/masterDataSystem/chain-architecture-label-config',
    name: 'chainArchitectureLabelConfig',
    component: () =>
      import(
        /*webpackChunkName:"behaviorManageAmendRecord" */
        '@/views/master-data/system-settings/system-configuration/chain-architecture-label-config/Page.vue'
      ),
    meta: {
      SecondaryMenu: '系统设置', //二级菜单
      title: '连锁架构标签配置',
      breadcrumb: [
        {
          title: '系统配置',
          name: 'masterDataSettingManage'
        }
      ]
    }
  },

  // 产品字段管理
  {
    path: '/masterDataSystem/product-management',
    name: 'masterDataProductManagement',
    component: () =>
      // import(
      //   /*webpackChunkName:"masterDataProductManagement" */
      //   '@/views/masterDataSystem/product/management.vue'
      // ), 待删除
      import(
        /*webpackChunkName:"masterDataProductManagement" */
        '@/views/master-data/system-settings/product-field-management/Page.vue'
      ),
    meta: {
      SecondaryMenu: '系统设置', //二级菜单
      title: '产品字段管理'
    }
  },
  // 产品字段管理  编辑  添加字段
  {
    path: '/masterDataSystem/product-edit/:meta_type/:id',
    name: 'masterDataProductEdit',
    component: () =>
      // import(
      //   /*webpackChunkName:"masterDataProductEdit" */
      //   '@/views/masterDataSystem/product/edit.vue'
      // ), 待删除
      import(
        /*webpackChunkName:"masterDataProductEdit" */
        '@/views/master-data/system-settings/product-field-management/Edit.vue'
      ),
    meta: {
      SecondaryMenu: '系统设置', //二级菜单
      isMoreMeta: true,
      1: {
        title: '添加字段',
        breadcrumb: [
          {
            title: '产品字段管理',
            name: 'masterDataProductManagement'
          }
        ]
      },
      2: {
        title: '编辑字段',
        breadcrumb: [
          {
            title: '产品字段管理',
            name: 'masterDataProductManagement'
          }
        ]
      }
    }
  },

  // 操作日志 主数据
  {
    path: '/masterDataSystem/operation-log/:meta_type',
    name: 'masterDataSystemOperationLog',
    component: () =>
      // import(
      //   /*webpackChunkName:"bonusReturnSystemCategory" */
      //   '@/views/masterDataSystem/OperationLog.vue'
      // ), 待删除
      import(
        /*webpackChunkName:"bonusReturnSystemCategory" */
        '@/views/master-data/system-settings/operation-log/Page.vue'
      ),
    meta: {
      SecondaryMenu: '系统设置', //二级菜单
      title: '操作日志'
    }
  },

  // 产品标签配置
  {
    path: '/masterDataSystem/goods-tag-management',
    name: 'masterDataGoodsTagManagement',
    component: () =>
      // import(
      //   /*webpackChunkName:"masterDataProductManagement" */
      //   '@/views/masterDataSystem/goods/TagManage.vue'
      // ), 待删除
      import(
        /*webpackChunkName:"masterDataProductManagement" */
        '@/views/master-data/system-settings/product-label-configuration/Page.vue'
      ),
    meta: {
      SecondaryMenu: '系统设置', //二级菜单
      title: '产品标签配置'
    }
  },
  // 标签管理
  {
    path: '/masterDataSystem/label-management',
    name: 'masterDataLabelManagement',
    component: () =>
      import(
        /*webpackChunkName:"masterDataProductManagement" */
        '@/views/master-data/system-settings/label-management/Page.vue'
      ),
    meta: {
      SecondaryMenu: '系统设置', //二级菜单
      title: '标签管理'
    }
  },
  // 标签管理  添加标签   编辑标签
  {
    path: '/masterDataSystem/add-Label/:meta_type/:id',
    name: 'masterDataAddLabel',
    component: () =>
      import(
        /*webpackChunkName:"masterDataProductEdit" */
        '@/views/master-data/system-settings/label-management/Add.vue'
      ),
    meta: {
      SecondaryMenu: '系统设置', //二级菜单
      breadcrumb: [
        {
          title: '标签管理',
          name: 'masterDataLabelManagement'
        }
      ]
    }
  }
]

export default systemSettingRouter
